var _rect, _tspan, _rect2, _tspan2, _rect3, _tspan3, _rect4, _tspan4, _rect5, _tspan5, _rect6, _tspan6, _rect7, _tspan7, _g, _line, _rect8, _tspan8, _line2, _rect9, _tspan9, _line3, _rect0, _tspan0, _line4, _rect1, _tspan1, _line5, _rect10, _tspan10, _line6, _rect11, _tspan11, _line7, _rect12, _tspan12, _g2, _style, _g3, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs0, _line8, _line9, _line0, _line1, _polygon, _tspan13, _line10, _line11, _line12, _line13, _polygon2, _tspan14, _line14, _line15, _line16, _line17, _polygon3, _tspan15, _line18, _line19, _line20, _line21, _polygon4, _tspan16, _line22, _line23, _line24, _line25, _polygon5, _tspan17, _line26, _line27, _line28, _line29, _polygon6, _tspan18, _line30, _line31, _line32, _line33, _circle, _tspan19, _line34, _text, _line35, _text2, _line36, _text3, _line37, _text4, _line38, _text5, _line39, _text6, _line40, _text7, _line41, _text8, _line42, _text9, _line43, _text0, _line44, _text1, _line45, _text10, _line46, _text11, _line47, _text12, _line48, _text13, _line49, _text14, _line50, _text15, _line51, _text16, _line52, _text17, _line53, _text18, _line54, _text19, _line55, _text20, _line56, _text21, _line57, _text22, _line58, _text23, _line59, _text24, _line60, _text25, _line61, _text26, _line62, _text27, _line63, _text28, _line64, _text29, _line65, _text30, _line66, _text31, _line67, _text32, _line68, _text33, _line69, _text34, _line70, _text35, _line71, _text36, _line72, _text37, _line73, _text38, _line74, _text39, _line75, _text40, _line76, _text41, _line77, _text42, _line78, _text43, _line79, _text44, _line80, _text45, _line81, _text46, _line82, _text47, _line83, _text48, _line84, _text49, _line85, _text50, _line86, _text51, _line87, _text52, _line88, _text53, _line89, _text54, _line90, _text55, _line91, _text56, _line92, _text57, _line93, _text58, _line94, _text59, _line95, _text60, _line96, _text61, _line97, _text62, _line98, _text63, _line99, _text64, _line100, _text65, _line101, _text66, _line102, _line103, _line104, _line105, _circle2, _tspan20;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthenticationTrafficShapingSequence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-svg",
    width: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      maxWidth: 2261,
      backgroundColor: "white"
    },
    viewBox: "-50 -10 2261 4123",
    role: "graphics-document document",
    "aria-roledescription": "sequence",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2011,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "TC",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 2086,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 2086,
    dy: 0
  }, "Linux tc/qdisc")))), /*#__PURE__*/React.createElement("g", null, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1681,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "API",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 1756,
    dy: 0
  }, "VPN REST API")))), /*#__PURE__*/React.createElement("g", null, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1459,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 172,
    height: 65,
    name: "DB",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1545,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 1545,
    dy: 0
  }, "Subscription/Usage DB")))), /*#__PURE__*/React.createElement("g", null, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "Redis",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1334,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 1334,
    dy: 0
  }, "Redis")))), /*#__PURE__*/React.createElement("g", null, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 894.5,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 163,
    height: 65,
    name: "Hook",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 976,
    dy: 0
  }, "Perl Accounting Hook")))), /*#__PURE__*/React.createElement("g", null, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "Radius",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 663,
    dy: 0
  }, "FreeRADIUS")))), /*#__PURE__*/React.createElement("g", null, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 4037,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "VPN",
    rx: 3,
    ry: 3,
    className: "actor actor-bottom"
  })), /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 4069.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 348,
    dy: 0
  }, "VPN Gateway")))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), /*#__PURE__*/React.createElement("g", null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "actor7",
    x1: 2086,
    y1: 65,
    x2: 2086,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "TC",
    "data-et": "life-line",
    "data-id": "TC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-7",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "TC"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2011,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "TC",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 2086,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 2086,
    dy: 0
  }, "Linux tc/qdisc"))))), /*#__PURE__*/React.createElement("g", null, _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "actor6",
    x1: 1756,
    y1: 65,
    x2: 1756,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "API",
    "data-et": "life-line",
    "data-id": "API"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-6",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "API"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1681,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "API",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 1756,
    dy: 0
  }, "VPN REST API"))))), /*#__PURE__*/React.createElement("g", null, _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "actor5",
    x1: 1545,
    y1: 65,
    x2: 1545,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "DB",
    "data-et": "life-line",
    "data-id": "DB"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-5",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "DB"
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 1459,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 172,
    height: 65,
    name: "DB",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1545,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 1545,
    dy: 0
  }, "Subscription/Usage DB"))))), /*#__PURE__*/React.createElement("g", null, _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "actor4",
    x1: 1334,
    y1: 65,
    x2: 1334,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "Redis",
    "data-et": "life-line",
    "data-id": "Redis"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-4",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "Redis"
  }, _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 1259,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "Redis",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 1334,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 1334,
    dy: 0
  }, "Redis"))))), /*#__PURE__*/React.createElement("g", null, _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "actor3",
    x1: 976,
    y1: 65,
    x2: 976,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "Hook",
    "data-et": "life-line",
    "data-id": "Hook"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-3",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "Hook"
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 894.5,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 163,
    height: 65,
    name: "Hook",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 976,
    dy: 0
  }, "Perl Accounting Hook"))))), /*#__PURE__*/React.createElement("g", null, _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "actor2",
    x1: 663,
    y1: 65,
    x2: 663,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "Radius",
    "data-et": "life-line",
    "data-id": "Radius"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-2",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "Radius"
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 588,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "Radius",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 663,
    dy: 0
  }, "FreeRADIUS"))))), /*#__PURE__*/React.createElement("g", null, _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "actor1",
    x1: 348,
    y1: 65,
    x2: 348,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "VPN",
    "data-et": "life-line",
    "data-id": "VPN"
  })), /*#__PURE__*/React.createElement("g", {
    id: "root-1",
    "data-et": "participant",
    "data-type": "participant",
    "data-id": "VPN"
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 0,
    fill: "#eaeaea",
    stroke: "#666",
    width: 150,
    height: 65,
    name: "VPN",
    rx: 3,
    ry: 3,
    className: "actor actor-top"
  })), /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 32.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-box",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 348,
    dy: 0
  }, "VPN Gateway"))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    id: "actor0",
    x1: 75,
    y1: 80,
    x2: 75,
    y2: 4037,
    className: "actor-line 200",
    strokeWidth: "0.5px",
    stroke: "#999",
    name: "Client",
    "data-et": "life-line",
    "data-id": "Client"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:\"trebuchet ms\",verdana,arial,sans-serif;font-size:16px;fill:#333;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#552222;}#my-svg .error-text{fill:#552222;stroke:#552222;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#333333;stroke:#333333;}#my-svg .marker.cross{stroke:#333333;}#my-svg svg{font-family:\"trebuchet ms\",verdana,arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .actor{stroke:#9370DB;fill:#ECECFF;stroke-width:1;}#my-svg rect.actor.outer-path[data-look=\"neo\"]{filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg rect.note[data-look=\"neo\"]{stroke:#aaaa33;fill:#fff5ad;filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg text.actor&gt;tspan{fill:black;stroke:none;}#my-svg .actor-line{stroke:#9370DB;}#my-svg .innerArc{stroke-width:1.5;stroke-dasharray:none;}#my-svg .messageLine0{stroke-width:1.5;stroke-dasharray:none;stroke:#333;}#my-svg .messageLine1{stroke-width:1.5;stroke-dasharray:2,2;stroke:#333;}#my-svg [id$=\"-arrowhead\"] path{fill:#333;stroke:#333;}#my-svg .sequenceNumber{fill:white;}#my-svg [id$=\"-sequencenumber\"]{fill:#333;}#my-svg [id$=\"-crosshead\"] path{fill:#333;stroke:#333;}#my-svg .messageText{fill:#333;stroke:none;}#my-svg .labelBox{stroke:#9370DB;fill:#ECECFF;filter:none;}#my-svg .labelText,#my-svg .labelText&gt;tspan{fill:black;stroke:none;}#my-svg .loopText,#my-svg .loopText&gt;tspan{fill:black;stroke:none;}#my-svg .loopLine{stroke-width:2px;stroke-dasharray:2,2;stroke:#9370DB;fill:#9370DB;}#my-svg .note{stroke:#aaaa33;fill:#fff5ad;}#my-svg .noteText,#my-svg .noteText&gt;tspan{fill:black;stroke:none;font-weight:normal;}#my-svg .activation0{fill:#f4f4f4;stroke:#666;}#my-svg .activation1{fill:#f4f4f4;stroke:#666;}#my-svg .activation2{fill:#f4f4f4;stroke:#666;}#my-svg .actorPopupMenu{position:absolute;}#my-svg .actorPopupMenuPanel{position:absolute;fill:#ECECFF;box-shadow:0px 8px 16px 0px rgba(0,0,0,0.2);filter:drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));}#my-svg .actor-man circle,#my-svg line{fill:#ECECFF;stroke-width:2px;}#my-svg g rect.rect{filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));stroke:#9370DB;}#my-svg .node .neo-node{stroke:#9370DB;}#my-svg [data-look=\"neo\"].node rect,#my-svg [data-look=\"neo\"].cluster rect,#my-svg [data-look=\"neo\"].node polygon{stroke:#9370DB;filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg [data-look=\"neo\"].node path{stroke:#9370DB;stroke-width:1px;}#my-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg [data-look=\"neo\"].node .neo-line path{stroke:#9370DB;filter:none;}#my-svg [data-look=\"neo\"].node circle{stroke:#9370DB;filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#my-svg [data-look=\"neo\"].icon-shape .icon{fill:#9370DB;filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:#9370DB;filter:drop-shadow(1px 2px 2px rgba(185, 185, 185, 1));}#my-svg :root{--mermaid-font-family:\"trebuchet ms\",verdana,arial,sans-serif;}")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "my-svg-computer",
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "M2 2v13h20v-13h-20zm18 11h-16v-9h16v9zm-10.228 6l.466-1h3.524l.467 1h-4.457zm14.228 3h-24l2-6h2.104l-1.33 4h18.45l-1.297-4h2.073l2 6zm-5-10h-14v-7h14v7z"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "my-svg-database",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "M12.258.001l.256.004.255.005.253.008.251.01.249.012.247.015.246.016.242.019.241.02.239.023.236.024.233.027.231.028.229.031.225.032.223.034.22.036.217.038.214.04.211.041.208.043.205.045.201.046.198.048.194.05.191.051.187.053.183.054.18.056.175.057.172.059.168.06.163.061.16.063.155.064.15.066.074.033.073.033.071.034.07.034.069.035.068.035.067.035.066.035.064.036.064.036.062.036.06.036.06.037.058.037.058.037.055.038.055.038.053.038.052.038.051.039.05.039.048.039.047.039.045.04.044.04.043.04.041.04.04.041.039.041.037.041.036.041.034.041.033.042.032.042.03.042.029.042.027.042.026.043.024.043.023.043.021.043.02.043.018.044.017.043.015.044.013.044.012.044.011.045.009.044.007.045.006.045.004.045.002.045.001.045v17l-.001.045-.002.045-.004.045-.006.045-.007.045-.009.044-.011.045-.012.044-.013.044-.015.044-.017.043-.018.044-.02.043-.021.043-.023.043-.024.043-.026.043-.027.042-.029.042-.03.042-.032.042-.033.042-.034.041-.036.041-.037.041-.039.041-.04.041-.041.04-.043.04-.044.04-.045.04-.047.039-.048.039-.05.039-.051.039-.052.038-.053.038-.055.038-.055.038-.058.037-.058.037-.06.037-.06.036-.062.036-.064.036-.064.036-.066.035-.067.035-.068.035-.069.035-.07.034-.071.034-.073.033-.074.033-.15.066-.155.064-.16.063-.163.061-.168.06-.172.059-.175.057-.18.056-.183.054-.187.053-.191.051-.194.05-.198.048-.201.046-.205.045-.208.043-.211.041-.214.04-.217.038-.22.036-.223.034-.225.032-.229.031-.231.028-.233.027-.236.024-.239.023-.241.02-.242.019-.246.016-.247.015-.249.012-.251.01-.253.008-.255.005-.256.004-.258.001-.258-.001-.256-.004-.255-.005-.253-.008-.251-.01-.249-.012-.247-.015-.245-.016-.243-.019-.241-.02-.238-.023-.236-.024-.234-.027-.231-.028-.228-.031-.226-.032-.223-.034-.22-.036-.217-.038-.214-.04-.211-.041-.208-.043-.204-.045-.201-.046-.198-.048-.195-.05-.19-.051-.187-.053-.184-.054-.179-.056-.176-.057-.172-.059-.167-.06-.164-.061-.159-.063-.155-.064-.151-.066-.074-.033-.072-.033-.072-.034-.07-.034-.069-.035-.068-.035-.067-.035-.066-.035-.064-.036-.063-.036-.062-.036-.061-.036-.06-.037-.058-.037-.057-.037-.056-.038-.055-.038-.053-.038-.052-.038-.051-.039-.049-.039-.049-.039-.046-.039-.046-.04-.044-.04-.043-.04-.041-.04-.04-.041-.039-.041-.037-.041-.036-.041-.034-.041-.033-.042-.032-.042-.03-.042-.029-.042-.027-.042-.026-.043-.024-.043-.023-.043-.021-.043-.02-.043-.018-.044-.017-.043-.015-.044-.013-.044-.012-.044-.011-.045-.009-.044-.007-.045-.006-.045-.004-.045-.002-.045-.001-.045v-17l.001-.045.002-.045.004-.045.006-.045.007-.045.009-.044.011-.045.012-.044.013-.044.015-.044.017-.043.018-.044.02-.043.021-.043.023-.043.024-.043.026-.043.027-.042.029-.042.03-.042.032-.042.033-.042.034-.041.036-.041.037-.041.039-.041.04-.041.041-.04.043-.04.044-.04.046-.04.046-.039.049-.039.049-.039.051-.039.052-.038.053-.038.055-.038.056-.038.057-.037.058-.037.06-.037.061-.036.062-.036.063-.036.064-.036.066-.035.067-.035.068-.035.069-.035.07-.034.072-.034.072-.033.074-.033.151-.066.155-.064.159-.063.164-.061.167-.06.172-.059.176-.057.179-.056.184-.054.187-.053.19-.051.195-.05.198-.048.201-.046.204-.045.208-.043.211-.041.214-.04.217-.038.22-.036.223-.034.226-.032.228-.031.231-.028.234-.027.236-.024.238-.023.241-.02.243-.019.245-.016.247-.015.249-.012.251-.01.253-.008.255-.005.256-.004.258-.001.258.001zm-9.258 20.499v.01l.001.021.003.021.004.022.005.021.006.022.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.023.018.024.019.024.021.024.022.025.023.024.024.025.052.049.056.05.061.051.066.051.07.051.075.051.079.052.084.052.088.052.092.052.097.052.102.051.105.052.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.048.144.049.147.047.152.047.155.047.16.045.163.045.167.043.171.043.176.041.178.041.183.039.187.039.19.037.194.035.197.035.202.033.204.031.209.03.212.029.216.027.219.025.222.024.226.021.23.02.233.018.236.016.24.015.243.012.246.01.249.008.253.005.256.004.259.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.021.224-.024.22-.026.216-.027.212-.028.21-.031.205-.031.202-.034.198-.034.194-.036.191-.037.187-.039.183-.04.179-.04.175-.042.172-.043.168-.044.163-.045.16-.046.155-.046.152-.047.148-.048.143-.049.139-.049.136-.05.131-.05.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.053.083-.051.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.05.023-.024.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.023.01-.022.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.127l-.077.055-.08.053-.083.054-.085.053-.087.052-.09.052-.093.051-.095.05-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.045-.118.044-.12.043-.122.042-.124.042-.126.041-.128.04-.13.04-.132.038-.134.038-.135.037-.138.037-.139.035-.142.035-.143.034-.144.033-.147.032-.148.031-.15.03-.151.03-.153.029-.154.027-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.01-.179.008-.179.008-.181.006-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.006-.179-.008-.179-.008-.178-.01-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.027-.153-.029-.151-.03-.15-.03-.148-.031-.146-.032-.145-.033-.143-.034-.141-.035-.14-.035-.137-.037-.136-.037-.134-.038-.132-.038-.13-.04-.128-.04-.126-.041-.124-.042-.122-.042-.12-.044-.117-.043-.116-.045-.113-.045-.112-.046-.109-.047-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.05-.093-.052-.09-.051-.087-.052-.085-.053-.083-.054-.08-.054-.077-.054v4.127zm0-5.654v.011l.001.021.003.021.004.021.005.022.006.022.007.022.009.022.01.022.011.023.012.023.013.023.015.024.016.023.017.024.018.024.019.024.021.024.022.024.023.025.024.024.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.052.11.051.114.051.119.052.123.05.127.051.131.05.135.049.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.044.171.042.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.022.23.02.233.018.236.016.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.012.241-.015.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.048.139-.05.136-.049.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.051.051-.049.023-.025.023-.024.021-.025.02-.024.019-.024.018-.024.017-.024.015-.023.014-.023.013-.024.012-.022.01-.023.01-.023.008-.022.006-.022.006-.022.004-.021.004-.022.001-.021.001-.021v-4.139l-.077.054-.08.054-.083.054-.085.052-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.049-.105.048-.106.047-.109.047-.111.046-.114.045-.115.044-.118.044-.12.044-.122.042-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.035-.143.033-.144.033-.147.033-.148.031-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.025-.161.024-.162.023-.163.022-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.011-.178.009-.179.009-.179.007-.181.007-.182.005-.182.004-.184.003-.184.002h-.37l-.184-.002-.184-.003-.182-.004-.182-.005-.181-.007-.179-.007-.179-.009-.178-.009-.176-.011-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.022-.162-.023-.161-.024-.159-.025-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.031-.146-.033-.145-.033-.143-.033-.141-.035-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.04-.126-.041-.124-.042-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.047-.105-.048-.102-.049-.1-.049-.097-.05-.095-.051-.093-.051-.09-.051-.087-.053-.085-.052-.083-.054-.08-.054-.077-.054v4.139zm0-5.666v.011l.001.02.003.022.004.021.005.022.006.021.007.022.009.023.01.022.011.023.012.023.013.023.015.023.016.024.017.024.018.023.019.024.021.025.022.024.023.024.024.025.052.05.056.05.061.05.066.051.07.051.075.052.079.051.084.052.088.052.092.052.097.052.102.052.105.051.11.052.114.051.119.051.123.051.127.05.131.05.135.05.139.049.144.048.147.048.152.047.155.046.16.045.163.045.167.043.171.043.176.042.178.04.183.04.187.038.19.037.194.036.197.034.202.033.204.032.209.03.212.028.216.027.219.025.222.024.226.021.23.02.233.018.236.017.24.014.243.012.246.01.249.008.253.006.256.003.259.001.26-.001.257-.003.254-.006.25-.008.247-.01.244-.013.241-.014.237-.016.233-.018.231-.02.226-.022.224-.024.22-.025.216-.027.212-.029.21-.03.205-.032.202-.033.198-.035.194-.036.191-.037.187-.039.183-.039.179-.041.175-.042.172-.043.168-.044.163-.045.16-.045.155-.047.152-.047.148-.048.143-.049.139-.049.136-.049.131-.051.126-.05.123-.051.118-.052.114-.051.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.052.07-.051.065-.051.06-.051.056-.05.051-.049.023-.025.023-.025.021-.024.02-.024.019-.024.018-.024.017-.024.015-.023.014-.024.013-.023.012-.023.01-.022.01-.023.008-.022.006-.022.006-.022.004-.022.004-.021.001-.021.001-.021v-4.153l-.077.054-.08.054-.083.053-.085.053-.087.053-.09.051-.093.051-.095.051-.097.05-.1.049-.102.048-.105.048-.106.048-.109.046-.111.046-.114.046-.115.044-.118.044-.12.043-.122.043-.124.042-.126.041-.128.04-.13.039-.132.039-.134.038-.135.037-.138.036-.139.036-.142.034-.143.034-.144.033-.147.032-.148.032-.15.03-.151.03-.153.028-.154.028-.156.027-.158.026-.159.024-.161.024-.162.023-.163.023-.165.021-.166.02-.167.019-.169.018-.169.017-.171.016-.173.015-.173.014-.175.013-.175.012-.177.01-.178.01-.179.009-.179.007-.181.006-.182.006-.182.004-.184.003-.184.001-.185.001-.185-.001-.184-.001-.184-.003-.182-.004-.182-.006-.181-.006-.179-.007-.179-.009-.178-.01-.176-.01-.176-.012-.175-.013-.173-.014-.172-.015-.171-.016-.17-.017-.169-.018-.167-.019-.166-.02-.165-.021-.163-.023-.162-.023-.161-.024-.159-.024-.157-.026-.156-.027-.155-.028-.153-.028-.151-.03-.15-.03-.148-.032-.146-.032-.145-.033-.143-.034-.141-.034-.14-.036-.137-.036-.136-.037-.134-.038-.132-.039-.13-.039-.128-.041-.126-.041-.124-.041-.122-.043-.12-.043-.117-.044-.116-.044-.113-.046-.112-.046-.109-.046-.106-.048-.105-.048-.102-.048-.1-.05-.097-.049-.095-.051-.093-.051-.09-.052-.087-.052-.085-.053-.083-.053-.08-.054-.077-.054v4.153zm8.74-8.179l-.257.004-.254.005-.25.008-.247.011-.244.012-.241.014-.237.016-.233.018-.231.021-.226.022-.224.023-.22.026-.216.027-.212.028-.21.031-.205.032-.202.033-.198.034-.194.036-.191.038-.187.038-.183.04-.179.041-.175.042-.172.043-.168.043-.163.045-.16.046-.155.046-.152.048-.148.048-.143.048-.139.049-.136.05-.131.05-.126.051-.123.051-.118.051-.114.052-.11.052-.106.052-.101.052-.096.052-.092.052-.088.052-.083.052-.079.052-.074.051-.07.052-.065.051-.06.05-.056.05-.051.05-.023.025-.023.024-.021.024-.02.025-.019.024-.018.024-.017.023-.015.024-.014.023-.013.023-.012.023-.01.023-.01.022-.008.022-.006.023-.006.021-.004.022-.004.021-.001.021-.001.021.001.021.001.021.004.021.004.022.006.021.006.023.008.022.01.022.01.023.012.023.013.023.014.023.015.024.017.023.018.024.019.024.02.025.021.024.023.024.023.025.051.05.056.05.06.05.065.051.07.052.074.051.079.052.083.052.088.052.092.052.096.052.101.052.106.052.11.052.114.052.118.051.123.051.126.051.131.05.136.05.139.049.143.048.148.048.152.048.155.046.16.046.163.045.168.043.172.043.175.042.179.041.183.04.187.038.191.038.194.036.198.034.202.033.205.032.21.031.212.028.216.027.22.026.224.023.226.022.231.021.233.018.237.016.241.014.244.012.247.011.25.008.254.005.257.004.26.001.26-.001.257-.004.254-.005.25-.008.247-.011.244-.012.241-.014.237-.016.233-.018.231-.021.226-.022.224-.023.22-.026.216-.027.212-.028.21-.031.205-.032.202-.033.198-.034.194-.036.191-.038.187-.038.183-.04.179-.041.175-.042.172-.043.168-.043.163-.045.16-.046.155-.046.152-.048.148-.048.143-.048.139-.049.136-.05.131-.05.126-.051.123-.051.118-.051.114-.052.11-.052.106-.052.101-.052.096-.052.092-.052.088-.052.083-.052.079-.052.074-.051.07-.052.065-.051.06-.05.056-.05.051-.05.023-.025.023-.024.021-.024.02-.025.019-.024.018-.024.017-.023.015-.024.014-.023.013-.023.012-.023.01-.023.01-.022.008-.022.006-.023.006-.021.004-.022.004-.021.001-.021.001-.021-.001-.021-.001-.021-.004-.021-.004-.022-.006-.021-.006-.023-.008-.022-.01-.022-.01-.023-.012-.023-.013-.023-.014-.023-.015-.024-.017-.023-.018-.024-.019-.024-.02-.025-.021-.024-.023-.024-.023-.025-.051-.05-.056-.05-.06-.05-.065-.051-.07-.052-.074-.051-.079-.052-.083-.052-.088-.052-.092-.052-.096-.052-.101-.052-.106-.052-.11-.052-.114-.052-.118-.051-.123-.051-.126-.051-.131-.05-.136-.05-.139-.049-.143-.048-.148-.048-.152-.048-.155-.046-.16-.046-.163-.045-.168-.043-.172-.043-.175-.042-.179-.041-.183-.04-.187-.038-.191-.038-.194-.036-.198-.034-.202-.033-.205-.032-.21-.031-.212-.028-.216-.027-.22-.026-.224-.023-.226-.022-.231-.021-.233-.018-.237-.016-.241-.014-.244-.012-.247-.011-.25-.008-.254-.005-.257-.004-.26-.001-.26.001z"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "my-svg-clock",
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.5)",
    d: "M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.848 12.459c.202.038.202.333.001.372-1.907.361-6.045 1.111-6.547 1.111-.719 0-1.301-.582-1.301-1.301 0-.512.77-5.447 1.125-7.445.034-.192.312-.181.343.014l.985 6.238 5.394 1.011z"
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-arrowhead",
    refX: 7.9,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -1 0 L 10 5 L 0 10 z"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-crosshead",
    markerWidth: 15,
    markerHeight: 8,
    orient: "auto",
    refX: 4,
    refY: 4.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: "1pt",
    d: "M 1,2 L 6,7 M 6,2 L 1,7",
    style: {
      strokeDasharray: "0, 0"
    }
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-filled-head",
    refX: 15.5,
    refY: 7,
    markerWidth: 20,
    markerHeight: 28,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18,7 L9,13 L14,7 L9,1 Z"
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-sequencenumber",
    refX: 15,
    refY: 15,
    markerWidth: 60,
    markerHeight: 40,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 6
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-solidTopArrowHead",
    refX: 7.9,
    refY: 7.25,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 8 L 0 8 z"
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-solidBottomArrowHead",
    refX: 7.9,
    refY: 0.75,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 0 L 0 8 z"
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-stickTopArrowHead",
    refX: 7.5,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 7 7",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  })))), _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg-stickBottomArrowHead",
    refX: 7.5,
    refY: 0,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 7 L 7 0",
    stroke: "black",
    strokeWidth: 1.5,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i20"
  }, _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 427,
    x2: 2097,
    y2: 427,
    className: "loopLine"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 2097,
    y1: 427,
    x2: 2097,
    y2: 914,
    className: "loopLine"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 914,
    x2: 2097,
    y2: 914,
    className: "loopLine"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 427,
    x2: 652,
    y2: 914,
    className: "loopLine"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 741,
    x2: 2097,
    y2: 741,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 830,
    x2: 2097,
    y2: 830,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "652,427 702,427 702,440 693.6,447 652,447",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 677,
    y: 440,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "alt"), /*#__PURE__*/React.createElement("text", {
    x: 1399.5,
    y: 445,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 1399.5
  }, "[User group is limited]"))), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 759,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[User group is premium or free]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 848,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Unknown group]")), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i46"
  }, _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 1352,
    x2: 2097,
    y2: 1352,
    className: "loopLine"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 2097,
    y1: 1352,
    x2: 2097,
    y2: 2060,
    className: "loopLine"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2060,
    x2: 2097,
    y2: 2060,
    className: "loopLine"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 1352,
    x2: 652,
    y2: 2060,
    className: "loopLine"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 1710,
    x2: 2097,
    y2: 1710,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 1887,
    x2: 2097,
    y2: 1887,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 1976,
    x2: 2097,
    y2: 1976,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "652,1352 702,1352 702,1365 693.6,1372 652,1372",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 677,
    y: 1365,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "alt"), /*#__PURE__*/React.createElement("text", {
    x: 1399.5,
    y: 1370,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 1399.5
  }, "[User is limited]"))), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 1728,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[User is premium and limited flag exists]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 1905,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[User is free]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 1994,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Unknown group]")), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i64"
  }, _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2115,
    x2: 2097,
    y2: 2115,
    className: "loopLine"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 2097,
    y1: 2115,
    x2: 2097,
    y2: 2853,
    className: "loopLine"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2853,
    x2: 2097,
    y2: 2853,
    className: "loopLine"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2115,
    x2: 652,
    y2: 2853,
    className: "loopLine"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2503,
    x2: 2097,
    y2: 2503,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2680,
    x2: 2097,
    y2: 2680,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 2769,
    x2: 2097,
    y2: 2769,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "652,2115 702,2115 702,2128 693.6,2135 652,2135",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 677,
    y: 2128,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "alt"), /*#__PURE__*/React.createElement("text", {
    x: 1399.5,
    y: 2133,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 1399.5
  }, "[User is limited]"))), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 2521,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[User is premium and limited flag exists]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 2698,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[User is free]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 2787,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Unknown group]")), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i65"
  }, _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 642,
    y1: 1307,
    x2: 2107,
    y2: 1307,
    className: "loopLine"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 2107,
    y1: 1307,
    x2: 2107,
    y2: 2863,
    className: "loopLine"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 642,
    y1: 2863,
    x2: 2107,
    y2: 2863,
    className: "loopLine"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 642,
    y1: 1307,
    x2: 642,
    y2: 2863,
    className: "loopLine"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 642,
    y1: 2075,
    x2: 2107,
    y2: 2075,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "642,1307 692,1307 692,1320 683.6,1327 642,1327",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 667,
    y: 1320,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "alt"), /*#__PURE__*/React.createElement("text", {
    x: 1399.5,
    y: 1325,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 1399.5
  }, "[Extra consumption detected]"))), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 2093,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[No extra consumption]")), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i67"
  }, _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 337,
    y1: 968,
    x2: 2117,
    y2: 968,
    className: "loopLine"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 2117,
    y1: 968,
    x2: 2117,
    y2: 2917,
    className: "loopLine"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 337,
    y1: 2917,
    x2: 2117,
    y2: 2917,
    className: "loopLine"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 337,
    y1: 968,
    x2: 337,
    y2: 2917,
    className: "loopLine"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "337,968 387,968 387,981 378.6,988 337,988",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 981,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "loop"), /*#__PURE__*/React.createElement("text", {
    x: 1252,
    y: 986,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 1252
  }, "[Every Acct-Interim-Update interval]")))), /*#__PURE__*/React.createElement("g", {
    "data-et": "control-structure",
    "data-id": "i90"
  }, _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3103,
    x2: 2097,
    y2: 3103,
    className: "loopLine"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 2097,
    y1: 3103,
    x2: 2097,
    y2: 3929,
    className: "loopLine"
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3929,
    x2: 2097,
    y2: 3929,
    className: "loopLine"
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3103,
    x2: 652,
    y2: 3929,
    className: "loopLine"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3579,
    x2: 2097,
    y2: 3579,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3756,
    x2: 2097,
    y2: 3756,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 652,
    y1: 3845,
    x2: 2097,
    y2: 3845,
    className: "loopLine",
    style: {
      strokeDasharray: "3, 3"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "652,3103 702,3103 702,3116 693.6,3123 652,3123",
    className: "labelBox"
  })), /*#__PURE__*/React.createElement("text", {
    x: 677,
    y: 3116,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "labelText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "alt"), /*#__PURE__*/React.createElement("text", {
    x: 1399.5,
    y: 3121,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 1399.5
  }, "[Limited flag exists and user group is limited]"))), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 3597,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Limited flag exists and user group is premium or free]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 3774,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Limited flag does not exist]"), /*#__PURE__*/React.createElement("text", {
    x: 1374.5,
    y: 3863,
    textAnchor: "middle",
    className: "loopText",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "[Unknown group]")), /*#__PURE__*/React.createElement("g", {
    className: "actor-man actor-top",
    name: "Client",
    "data-et": "participant",
    "data-type": "actor",
    "data-id": "Client",
    style: {
      stroke: "rgb(147, 112, 219)"
    }
  }, _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    id: "actor-man-torso0",
    x1: 75,
    y1: 25,
    x2: 75,
    y2: 45
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    id: "actor-man-arms0",
    x1: 57,
    y1: 33,
    x2: 93,
    y2: 33
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 60,
    x2: 75,
    y2: 45
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 45,
    x2: 91,
    y2: 60
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 10,
    r: 15,
    width: 150,
    height: 65
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 67.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-man",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    dy: 0
  }, "Client")))), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 80,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Connect to VPN"), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 109,
    x2: 344,
    y2: 109,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i1",
    "data-from": "Client",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 109,
    x2: 75,
    y2: 109,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 113,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "1")), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 124,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Authentication-Request"), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 153,
    x2: 659,
    y2: 153,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i2",
    "data-from": "VPN",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 153,
    x2: 348,
    y2: 153,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 157,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "2")), /*#__PURE__*/React.createElement("text", {
    x: 1103,
    y: 168,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Lookup user, subscription, group, usage state"), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 197,
    x2: 1541,
    y2: 197,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i3",
    "data-from": "Radius",
    "data-to": "DB",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 197,
    x2: 663,
    y2: 197,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 201,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "3")), /*#__PURE__*/React.createElement("text", {
    x: 1106,
    y: 212,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "User access decision and group"), /*#__PURE__*/React.createElement("line", {
    x1: 1550,
    y1: 241,
    x2: 667,
    y2: 241,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i4",
    "data-from": "DB",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 1545,
    y1: 241,
    x2: 1545,
    y2: 241,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 1545,
    y: 245,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "4")), /*#__PURE__*/React.createElement("text", {
    x: 507,
    y: 256,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Authentication-Accept"), /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 285,
    x2: 352,
    y2: 285,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i5",
    "data-from": "Radius",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 285,
    x2: 663,
    y2: 285,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 289,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "5")), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 300,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Request (Start)"), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 329,
    x2: 659,
    y2: 329,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i6",
    "data-from": "VPN",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 329,
    x2: 348,
    y2: 329,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 333,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "6")), /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 344,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Execute Perl hook for Start"), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 373,
    x2: 972,
    y2: 373,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i7",
    "data-from": "Radius",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 373,
    x2: 663,
    y2: 373,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 377,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "7")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 388,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Check limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 417,
    x2: 1330,
    y2: 417,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i8",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 417,
    x2: 976,
    y2: 417,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 421,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "8")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 477,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Insert session record with input/output octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 506,
    x2: 1330,
    y2: 506,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i10",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 506,
    x2: 976,
    y2: 506,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 510,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "9")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 521,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Apply traffic shaping for client"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 550,
    x2: 1752,
    y2: 550,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i11",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 550,
    x2: 976,
    y2: 550,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 554,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "10")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 565,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Create tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 594,
    x2: 2082,
    y2: 594,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i12",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 594,
    x2: 1756,
    y2: 594,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 598,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "11")), /*#__PURE__*/React.createElement("text", {
    x: 1923,
    y: 609,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Rule applied"), /*#__PURE__*/React.createElement("line", {
    x1: 2091,
    y1: 638,
    x2: 1760,
    y2: 638,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i13",
    "data-from": "TC",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 2086,
    y1: 638,
    x2: 2086,
    y2: 638,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 2086,
    y: 642,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "12")), /*#__PURE__*/React.createElement("text", {
    x: 1368,
    y: 653,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Shaping applied"), /*#__PURE__*/React.createElement("line", {
    x1: 1761,
    y1: 682,
    x2: 980,
    y2: 682,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i14",
    "data-from": "API",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 682,
    x2: 1756,
    y2: 682,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 686,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "13")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 697,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Set limited flag for user"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 726,
    x2: 1330,
    y2: 726,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i15",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 726,
    x2: 976,
    y2: 726,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 730,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "14")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 786,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "No shaping required on Start"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 815,
    x2: 667,
    y2: 815,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i17",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 815,
    x2: 976,
    y2: 815,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 819,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "15")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 875,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Report error"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 904,
    x2: 667,
    y2: 904,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i19",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 904,
    x2: 976,
    y2: 904,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 908,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "16")), /*#__PURE__*/React.createElement("text", {
    x: 507,
    y: 929,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Accept"), /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 958,
    x2: 352,
    y2: 958,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i21",
    "data-from": "Radius",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 958,
    x2: 663,
    y2: 958,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 962,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "17")), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 1018,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Request (Interim-Update)"), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 1047,
    x2: 659,
    y2: 1047,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i23",
    "data-from": "VPN",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 1047,
    x2: 348,
    y2: 1047,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 1051,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "18")), /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 1062,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Execute Perl hook for Interim-Update"), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 1091,
    x2: 972,
    y2: 1091,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i24",
    "data-from": "Radius",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 1091,
    x2: 663,
    y2: 1091,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 1095,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "19")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 1106,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Read session counters and ignored octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1135,
    x2: 1330,
    y2: 1135,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i25",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1135,
    x2: 976,
    y2: 1135,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1139,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "20")), /*#__PURE__*/React.createElement("text", {
    x: 1259,
    y: 1150,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Read allowed usage and token/subscription state"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1179,
    x2: 1541,
    y2: 1179,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i26",
    "data-from": "Hook",
    "data-to": "DB",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1179,
    x2: 976,
    y2: 1179,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1183,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "21")), /*#__PURE__*/React.createElement("text", {
    x: 1262,
    y: 1194,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Current allowance, tokens, and group"), /*#__PURE__*/React.createElement("line", {
    x1: 1550,
    y1: 1223,
    x2: 980,
    y2: 1223,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i27",
    "data-from": "DB",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 1545,
    y1: 1223,
    x2: 1545,
    y2: 1223,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 1545,
    y: 1227,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "22")), /*#__PURE__*/React.createElement("text", {
    x: 977,
    y: 1238,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Calculate actual - allowed - ignored"), /*#__PURE__*/React.createElement("path", {
    d: "M 977,1267 C 1037,1257 1037,1297 977,1287",
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i28",
    "data-from": "Hook",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    x1: 983,
    style: {
      fill: "none"
    }
  }), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1267,
    x2: 976,
    y2: 1267,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1271,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "23")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 1402,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Query and remove session record"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1431,
    x2: 1330,
    y2: 1431,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i31",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1431,
    x2: 976,
    y2: 1431,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1435,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "24")), /*#__PURE__*/React.createElement("text", {
    x: 1259,
    y: 1446,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Change group to free"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1475,
    x2: 1541,
    y2: 1475,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i32",
    "data-from": "Hook",
    "data-to": "DB",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1475,
    x2: 976,
    y2: 1475,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1479,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "25")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 1490,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1519,
    x2: 1752,
    y2: 1519,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i33",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1519,
    x2: 976,
    y2: 1519,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1523,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "26")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 1534,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Delete tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 1563,
    x2: 2082,
    y2: 1563,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i34",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 1563,
    x2: 1756,
    y2: 1563,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 1567,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "27")), /*#__PURE__*/React.createElement("text", {
    x: 1923,
    y: 1578,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Rule removed"), /*#__PURE__*/React.createElement("line", {
    x1: 2091,
    y1: 1607,
    x2: 1760,
    y2: 1607,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i35",
    "data-from": "TC",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 2086,
    y1: 1607,
    x2: 2086,
    y2: 1607,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 2086,
    y: 1611,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "28")), /*#__PURE__*/React.createElement("text", {
    x: 1368,
    y: 1622,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Shaping removed"), /*#__PURE__*/React.createElement("line", {
    x1: 1761,
    y1: 1651,
    x2: 980,
    y2: 1651,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i36",
    "data-from": "API",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 1651,
    x2: 1756,
    y2: 1651,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 1655,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "29")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 1666,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1695,
    x2: 1330,
    y2: 1695,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i37",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1695,
    x2: 976,
    y2: 1695,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1699,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "30")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 1755,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1784,
    x2: 1752,
    y2: 1784,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i39",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1784,
    x2: 976,
    y2: 1784,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1788,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "31")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 1799,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Delete tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 1828,
    x2: 2082,
    y2: 1828,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i40",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 1828,
    x2: 1756,
    y2: 1828,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 1832,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "32")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 1843,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1872,
    x2: 1330,
    y2: 1872,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i41",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1872,
    x2: 976,
    y2: 1872,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1876,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "33")), /*#__PURE__*/React.createElement("text", {
    x: 1259,
    y: 1932,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Calculate and persist tokens used"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 1961,
    x2: 1541,
    y2: 1961,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i43",
    "data-from": "Hook",
    "data-to": "DB",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 1961,
    x2: 976,
    y2: 1961,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 1965,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "34")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 2021,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Report error"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 2050,
    x2: 667,
    y2: 2050,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i45",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2050,
    x2: 976,
    y2: 2050,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2054,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "35")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 2165,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Retrieve previous input/output octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2194,
    x2: 1330,
    y2: 2194,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i49",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2194,
    x2: 976,
    y2: 2194,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2198,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "36")), /*#__PURE__*/React.createElement("text", {
    x: 977,
    y: 2209,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Calculate interval octets"), /*#__PURE__*/React.createElement("path", {
    d: "M 977,2238 C 1037,2228 1037,2268 977,2258",
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i50",
    "data-from": "Hook",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    x1: 983,
    style: {
      fill: "none"
    }
  }), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2238,
    x2: 976,
    y2: 2238,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2242,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "37")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 2283,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Update input/output octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2312,
    x2: 1330,
    y2: 2312,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i51",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2312,
    x2: 976,
    y2: 2312,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2316,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "38")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 2327,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Increment ignored_octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2356,
    x2: 1330,
    y2: 2356,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i52",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2356,
    x2: 976,
    y2: 2356,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2360,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "39")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 2371,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Apply traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2400,
    x2: 1752,
    y2: 2400,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i53",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2400,
    x2: 976,
    y2: 2400,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2404,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "40")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 2415,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Create or update tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 2444,
    x2: 2082,
    y2: 2444,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i54",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 2444,
    x2: 1756,
    y2: 2444,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 2448,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "41")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 2459,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Set limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2488,
    x2: 1330,
    y2: 2488,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i55",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2488,
    x2: 976,
    y2: 2488,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2492,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "42")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 2548,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2577,
    x2: 1752,
    y2: 2577,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i57",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2577,
    x2: 976,
    y2: 2577,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2581,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "43")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 2592,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Delete tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 2621,
    x2: 2082,
    y2: 2621,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i58",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 2621,
    x2: 1756,
    y2: 2621,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 2625,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "44")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 2636,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2665,
    x2: 1330,
    y2: 2665,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i59",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2665,
    x2: 976,
    y2: 2665,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2669,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "45")), /*#__PURE__*/React.createElement("text", {
    x: 1259,
    y: 2725,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Calculate and persist tokens used"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 2754,
    x2: 1541,
    y2: 2754,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i61",
    "data-from": "Hook",
    "data-to": "DB",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2754,
    x2: 976,
    y2: 2754,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2758,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "46")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 2814,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Report error"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 2843,
    x2: 667,
    y2: 2843,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i63",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 2843,
    x2: 976,
    y2: 2843,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 2847,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "47")), /*#__PURE__*/React.createElement("text", {
    x: 507,
    y: 2878,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Accept"), /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 2907,
    x2: 352,
    y2: 2907,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i66",
    "data-from": "Radius",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 2907,
    x2: 663,
    y2: 2907,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 2911,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "48")), /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 2932,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Disconnect or connection drops"), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: 2961,
    x2: 344,
    y2: 2961,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i68",
    "data-from": "Client",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 2961,
    x2: 75,
    y2: 2961,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 2965,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "49")), /*#__PURE__*/React.createElement("text", {
    x: 504,
    y: 2976,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Request (Stop)"), /*#__PURE__*/React.createElement("line", {
    x1: 355,
    y1: 3005,
    x2: 659,
    y2: 3005,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i69",
    "data-from": "VPN",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 3005,
    x2: 348,
    y2: 3005,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 3009,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "50")), /*#__PURE__*/React.createElement("text", {
    x: 818,
    y: 3020,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Execute Perl hook for Stop"), /*#__PURE__*/React.createElement("line", {
    x1: 670,
    y1: 3049,
    x2: 972,
    y2: 3049,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i70",
    "data-from": "Radius",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 3049,
    x2: 663,
    y2: 3049,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 3053,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "51")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3064,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Check limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3093,
    x2: 1330,
    y2: 3093,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i71",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3093,
    x2: 976,
    y2: 3093,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3097,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "52")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3153,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Retrieve session input/output octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3182,
    x2: 1330,
    y2: 3182,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i73",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3182,
    x2: 976,
    y2: 3182,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3186,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "53")), /*#__PURE__*/React.createElement("text", {
    x: 977,
    y: 3197,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Calculate final interval octets"), /*#__PURE__*/React.createElement("path", {
    d: "M 977,3226 C 1037,3216 1037,3256 977,3246",
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i74",
    "data-from": "Hook",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    x1: 983,
    style: {
      fill: "none"
    }
  }), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3226,
    x2: 976,
    y2: 3226,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3230,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "54")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3271,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Update input/output octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3300,
    x2: 1330,
    y2: 3300,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i75",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3300,
    x2: 976,
    y2: 3300,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3304,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "55")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3315,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Increment ignored_octets"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3344,
    x2: 1330,
    y2: 3344,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i76",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3344,
    x2: 976,
    y2: 3344,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3348,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "56")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 3359,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3388,
    x2: 1752,
    y2: 3388,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i77",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3388,
    x2: 976,
    y2: 3388,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3392,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "57")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 3403,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Delete tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 3432,
    x2: 2082,
    y2: 3432,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i78",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 3432,
    x2: 1756,
    y2: 3432,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 3436,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "58")), /*#__PURE__*/React.createElement("text", {
    x: 1923,
    y: 3447,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Rule removed"), /*#__PURE__*/React.createElement("line", {
    x1: 2091,
    y1: 3476,
    x2: 1760,
    y2: 3476,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i79",
    "data-from": "TC",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    x1: 2086,
    y1: 3476,
    x2: 2086,
    y2: 3476,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    x: 2086,
    y: 3480,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "59")), /*#__PURE__*/React.createElement("text", {
    x: 1368,
    y: 3491,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Shaping removed"), /*#__PURE__*/React.createElement("line", {
    x1: 1761,
    y1: 3520,
    x2: 980,
    y2: 3520,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i80",
    "data-from": "API",
    "data-to": "Hook",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 3520,
    x2: 1756,
    y2: 3520,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 3524,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "60")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3535,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3564,
    x2: 1330,
    y2: 3564,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i81",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3564,
    x2: 976,
    y2: 3564,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3568,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "61")), /*#__PURE__*/React.createElement("text", {
    x: 1365,
    y: 3624,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove traffic shaping"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3653,
    x2: 1752,
    y2: 3653,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i83",
    "data-from": "Hook",
    "data-to": "API",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3653,
    x2: 976,
    y2: 3653,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3657,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "62")), /*#__PURE__*/React.createElement("text", {
    x: 1920,
    y: 3668,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Delete tc class and dst-IP filter"), /*#__PURE__*/React.createElement("line", {
    x1: 1763,
    y1: 3697,
    x2: 2082,
    y2: 3697,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i84",
    "data-from": "API",
    "data-to": "TC",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    x1: 1756,
    y1: 3697,
    x2: 1756,
    y2: 3697,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    x: 1756,
    y: 3701,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "63")), /*#__PURE__*/React.createElement("text", {
    x: 1154,
    y: 3712,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Remove limited flag"), /*#__PURE__*/React.createElement("line", {
    x1: 983,
    y1: 3741,
    x2: 1330,
    y2: 3741,
    className: "messageLine0",
    "data-et": "message",
    "data-id": "i85",
    "data-from": "Hook",
    "data-to": "Redis",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      fill: "none"
    }
  }), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3741,
    x2: 976,
    y2: 3741,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3745,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "64")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 3801,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "No shaping cleanup required"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 3830,
    x2: 667,
    y2: 3830,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i87",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3830,
    x2: 976,
    y2: 3830,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3834,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "65")), /*#__PURE__*/React.createElement("text", {
    x: 821,
    y: 3890,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Report error"), /*#__PURE__*/React.createElement("line", {
    x1: 981,
    y1: 3919,
    x2: 667,
    y2: 3919,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i89",
    "data-from": "Hook",
    "data-to": "Radius",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    x1: 976,
    y1: 3919,
    x2: 976,
    y2: 3919,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    x: 976,
    y: 3923,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "66")), /*#__PURE__*/React.createElement("text", {
    x: 507,
    y: 3944,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Accounting-Accept / Stop handled"), /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 3973,
    x2: 352,
    y2: 3973,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i91",
    "data-from": "Radius",
    "data-to": "VPN",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    x1: 663,
    y1: 3973,
    x2: 663,
    y2: 3973,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    x: 663,
    y: 3977,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "67")), /*#__PURE__*/React.createElement("text", {
    x: 213,
    y: 3988,
    textAnchor: "middle",
    dominantBaseline: "middle",
    alignmentBaseline: "middle",
    className: "messageText",
    dy: "1em",
    style: {
      fontSize: 16,
      fontWeight: 400
    }
  }, "Session closed"), /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 4017,
    x2: 79,
    y2: 4017,
    className: "messageLine1",
    "data-et": "message",
    "data-id": "i92",
    "data-from": "VPN",
    "data-to": "Client",
    strokeWidth: 2,
    stroke: "none",
    markerEnd: "url(#my-svg-arrowhead)",
    style: {
      strokeDasharray: "3, 3",
      fill: "none"
    }
  }), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    x1: 348,
    y1: 4017,
    x2: 348,
    y2: 4017,
    strokeWidth: 0,
    markerStart: "url(#my-svg-sequencenumber)"
  })), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    x: 348,
    y: 4021,
    fontFamily: "sans-serif",
    fontSize: "12px",
    textAnchor: "middle",
    className: "sequenceNumber"
  }, "68")), /*#__PURE__*/React.createElement("g", {
    className: "actor-man actor-bottom",
    name: "Client",
    style: {
      stroke: "rgb(147, 112, 219)"
    }
  }, _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    id: "actor-man-torso7",
    x1: 75,
    y1: 4062,
    x2: 75,
    y2: 4082
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    id: "actor-man-arms7",
    x1: 57,
    y1: 4070,
    x2: 93,
    y2: 4070
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: 4097,
    x2: 75,
    y2: 4082
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: 4082,
    x2: 91,
    y2: 4097
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 4047,
    r: 15,
    width: 150,
    height: 65
  })), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 4104.5,
    dominantBaseline: "central",
    alignmentBaseline: "central",
    className: "actor actor-man",
    style: {
      textAnchor: "middle",
      fontSize: 16,
      fontWeight: 400
    }
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    dy: 0
  }, "Client")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticationTrafficShapingSequence);
export default __webpack_public_path__ + "static/media/authentication-traffic-shaping-sequence.3122ccfe88eb9c4bfb7e9426b1945c7f.svg";
export { ForwardRef as ReactComponent };